"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.retrieveMuiTheme = exports.retrieveStyle = void 0;

var _seamlessImmutable = require("seamless-immutable");

var _styles = require("@material-ui/core/styles");

var _colors = _interopRequireDefault(require("../../scss/variables/_colors.scss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var retrieveStyle = function retrieveStyle(theme) {
  return {
    error: {
      backgroundColor: (0, _seamlessImmutable.getIn)(theme, ['UTAlert', 'error', 'backgroundColor'], _colors["default"].notificationError)
    },
    info: {
      backgroundColor: (0, _seamlessImmutable.getIn)(theme, ['UTAlert', 'info', 'backgroundColor'], _colors["default"].notificationInfo)
    },
    success: {
      backgroundColor: (0, _seamlessImmutable.getIn)(theme, ['UTAlert', 'success', 'backgroundColor'], _colors["default"].notificationSuccess)
    },
    warning: {
      backgroundColor: (0, _seamlessImmutable.getIn)(theme, ['UTAlert', 'warning', 'backgroundColor'], _colors["default"].notificationWarning)
    }
  };
};

exports.retrieveStyle = retrieveStyle;

var retrieveMuiTheme = function retrieveMuiTheme(theme) {
  return (0, _styles.createMuiTheme)({
    typography: {
      fontFamily: (0, _seamlessImmutable.getIn)(theme, ['Fonts', 'fontFamily'])
    },
    overrides: {
      MuiSnackbarContent: {
        root: {
          minWidth: 288,
          maxWidth: 568,
          '@media (max-width : 767px)': {
            borderRadius: 0,
            width: '100%',
            maxWidth: 'initial'
          }
        }
      },
      MuiSnackbar: {
        root: {
          '@media (max-width : 767px)': {
            maxWidth: 'initial',
            width: '100%',
            left: 0,
            right: 0
          }
        },
        anchorOriginBottomLeft: {
          bottom: 0,
          '@media (max-width : 767px)': {
            bottom: 0,
            left: 0
          }
        }
      }
    }
  });
};

exports.retrieveMuiTheme = retrieveMuiTheme;